var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaBgMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 904,
    height: 520,
    viewBox: "0 0 904 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_282_3556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 904,
    height: 520
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 8C160 3.58172 163.582 0 168 0H896C900.418 0 904 3.58172 904 8V277.578C904 279.157 903.532 280.701 902.656 282.015L849.344 361.985C848.468 363.299 848 364.843 848 366.422V512C848 516.418 844.418 520 840 520H8C3.58172 520 0 516.418 0 512V48C0 43.5817 3.58172 40 8 40H152C156.418 40 160 36.4183 160 32V8Z",
    fill: "#EA1C1C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_282_3556)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -114,
    width: 1132,
    height: 520,
    fill: "#EA1C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaBgMask);
export default __webpack_public_path__ + "static/media/insta-bg-mask.5e21781e7ba976a3e60f6ae128072a13.svg";
export { ForwardRef as ReactComponent };